import styles from "../../Styles/TextInfo.module.css";

const TextInfo = ({ children, isUser = false, ...rest }) => {
  return (
    <p
      {...rest}
      className={`${styles["text-info"]} ${
        isUser ? styles["text-info--user"] : styles["text-info--log"]
      }`}
    >
      {children}
    </p>
  );
};
export default TextInfo;
